import { Component, inject, type OnDestroy, type OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { SwUpdate } from "@angular/service-worker";

import { ToastModule } from "primeng/toast";
import { EventListener } from "./shared/models";

@Component({
  selector: "app-root",
  imports: [ToastModule, RouterOutlet],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.css",
})
export class AppComponent implements OnInit, OnDestroy {
  private swUpdate = inject(SwUpdate);
  private visibilityHandler = () => this.checkForUpdates();

  ngOnInit(): void {
    // 1. Checks for updates at app startup
    this.checkForUpdates();

    // 2. Check when the app comes back into focus (wake up, tab resumed)
    document.addEventListener(EventListener.visibilitychange, this.visibilityHandler);
  }

  ngOnDestroy(): void {
    document.removeEventListener(EventListener.visibilitychange, this.visibilityHandler);
  }

  private checkForUpdates(): void {
    if (!this.swUpdate.isEnabled) return;

    this.swUpdate.checkForUpdate().then((hasUpdate) => {
      if (hasUpdate) {
        // Forces the application to use the new version immediately
        this.swUpdate.activateUpdate().then(() => {
          document.location.reload();
        });
      }
    });
  }
}
